package services.http

import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import kotlinx.serialization.DeserializationStrategy
import services.wunschsolarJson

/**
 * Decodes the response body using an explicitly provided [deserializer] and the shared `wunschsolarJson`.
 *
 * #2098: Ktor's `.body()` resolves the serializer reflectively from `TypeInfo`, which on Kotlin/JS
 * mis-resolves sealed types in the full app bundle (the class discriminator `type` is treated as an
 * unknown key). Passing the compiler-generated `<Type>.serializer()` explicitly bypasses that.
 */
suspend fun <T> HttpResponse.wunschsolarBody(deserializer: DeserializationStrategy<T>): T {
  return wunschsolarJson.decodeFromString(deserializer, bodyAsText())
}
